module.exports = __webpack_public_path__ + "img/30.d23957d8.jpg";